import ScrollTrigger from 'gsap/ScrollTrigger';
import { initTelInputs } from '../components/telInput';

let loaded = false;

function loadScript() {
  if (!loaded) {
    const script = document.createElement('script');
    script.src = '//js.hsforms.net/forms/embed/v2.js';
    document.body.appendChild(script);
    loaded = true;
  }

  return new Promise((resolve) => {
    if (window.hbspt) {
      resolve();
      return;
    }

    const interval = setInterval(() => {
      if (window.hbspt) {
        clearInterval(interval);
        resolve();
        return;
      }
    }, 500);
  });
}

function getHsFormConversionPage(fallbackValue) {
  if (document.referrer === undefined || document.referrer.length === 0) {
    return fallbackValue;
  } else {
    return String(document.referrer);
  }
}

export async function embedHsForm(
  targetSelector,
  hsFormParams = {},
  redirectToOnSubmit = null,
) {
  const target = document.querySelector(targetSelector);
  if (!target) return;

  ScrollTrigger.create({
    trigger: target,
    start: 'top-=1000 bottom',
    once: true,
    onEnter: async () => {
      await loadScript();
      initForm(targetSelector, hsFormParams, redirectToOnSubmit);
    },
  });
}

async function initForm(targetSelector, hsFormParams, redirectToOnSubmit) {
  const target = document.querySelector(targetSelector);
  redirectToOnSubmit = redirectToOnSubmit || target.dataset.redirectToOnSubmit;

  const requiredParams = ['region', 'portalId', 'formId', 'target'];
  const params = { ...hsFormParams, ...target.dataset, target: targetSelector };
  for (let param of requiredParams) {
    if (!Object.keys(params).includes(param)) {
      console.error(
        `Required param ${param} is not set for ${targetSelector} HsForm`,
      );
      return;
    }
  }

  const embeddedHsForm = hbspt.forms.create({
    ...params,
    css: '',
    onFormReady: function (form) {
      initTelInputs();
      let formElement = null;
      let regex = /hsForm/;
      if (!!form && form.nodeType === Node.ELEMENT_NODE) {
        formElement = form;
      } else if (!!form && typeof form === 'object') {
        for (var i = 0; i < form.length; i++) {
          if (!!form[i].id && regex.test(form[i].id)) {
            formElement = form[i];
            break;
          }
        }
      } else {
        return;
      }
      const textarea = formElement.querySelector('.hs-fieldtype-textarea');
      textarea.addEventListener('keyup', (element) => {
        if (!!element.target) {
          element.target.style.height = element.target.scrollHeight + 'px';
        }
      });

      embeddedHsForm.setFieldValue(
        'conversion_page',
        getHsFormConversionPage('No conversion page'),
      );

      try {
        var conversionPageUrl = getHsFormConversionPage('');
        if (!!conversionPageUrl && conversionPageUrl.length > 0) {
          embeddedHsForm.getContext().pageTitle = '';
          embeddedHsForm.getContext().pageUrl = conversionPageUrl;
        }
      } catch (e) {
        console.error(e);
      }
    },
    onFormSubmitted: () => {
      if (redirectToOnSubmit) window.location = redirectToOnSubmit;
    },
  });
}
